import { render, staticRenderFns } from "./ConfirmSignUp.vue?vue&type=template&id=ffde009c&"
import script from "./ConfirmSignUp.vue?vue&type=script&lang=js&"
export * from "./ConfirmSignUp.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmSignUp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports